<template>
  <page-listado>
    <page-header title="Países">
      <b-button variant="primary" size="sm" to="/paises/crear">
        <v-icon name="plus" width="16" />
        Crear país
      </b-button>
      <busqueda-rapida />
    </page-header>

    <tabla :paises="resultado.paises" @eliminar="eliminar" />
    <paginacion :page-count="resultado.totalPages" :page="resultado.currentPage" />
  </page-listado>
</template>

<script>
import * as paisesApi from "@/services/paises.js";
import Tabla from "./TablaPaises.vue";
export default {
  components: { Tabla },
  data() {
    return {
      resultado: {
        paises: [],
        totalPages: 0,
        currentPage: 1,
      },
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return paisesApi.listar(this.$route.query).then((resultado) => {
        this.resultado = resultado;
      });
    },
    eliminar(id) {
      return paisesApi.eliminar(id).then(() => {
        this.listar();
      });
    },
  },
};
</script>
